import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../index"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import SbImageService from "../../helpers/SbImageService"

const ProgramCategory = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div className={`${blok.wide ? "program-category program-category--wide" : "program-category program-category--tall"} ${className}`}>
      <div className={`program-category__inner`} style={{ backgroundImage: `url("${SbImageService(blok.image.filename)}")` }}>
        <div className={`program-category__inner-top`}>
          {blok.abbreviation && (
            <div className={`program-category__abbreviation`}>{blok.abbreviation}</div>
          )}
          {blok.title && (
            <p className={`program-category__title`}>{blok.title}</p>
          )}
          <div className="program-category__description">
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment
                })
                .processSync(blok.description).result
            }
          </div>
        </div>
        {blok.button && (
          <div className={`program-category__inner-bottom`}>
            {blok.button && blok.button.map(
              (content) =>
                React.createElement(Components(content.component),
                  {
                    key: content._uid,
                    blok: content,
                    className: "program-category__button",
                  }
                )
            )}
          </div>
        )}
      </div>
    </div>
  </SbEditable>
)

ProgramCategory.propTypes = {
  blok: PropTypes.shape({
    abbreviation: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.arrayOf(PropTypes.object),
    wide: PropTypes.bool,
  }).isRequired,
}

export default ProgramCategory
